import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import toast from "../../components/base/Toast";
import { UserIcon } from "../../assets/img/icons";

// Configs
import {
  isLoggedIn,
  isSuperAdmin,
  isCompanyAdmin,
  isCompanyManager,
  getKeyValueByObject,
  getParamsByName
} from "../../lib/helper";

// Components
import AvatarCard from "../../components/base/AvatarCard";
import PageTitle from "../../components/base/PageTitle";
import ReduxTable, { ReduxColumn } from "../../components/base/ReduxTable";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import CountBadge from "../../components/base/CountBadge";
import Form from "../../components/base/Form";
import UserRole from "../../components/UserRole";

import { DropdownItem } from "reactstrap";
import MoreDropdown from "../../components/base/MoreDropdown";

// API call
import { apiClient } from "../../apiClient";
// Configs
import { endpoints } from "../../configs";

// Actions
import { fetchList } from "../../actions/table";

import { Link } from "react-router-dom";
import Avatar from "../../components/base/Avatar";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import CancelButton from "../../components/base/CancelButton";
// Helper
import { getFullName } from "../../lib/helper";

// Constants
import {
  CUSTOMER_ROLE,
  CUSTOMER_ROLE_TEXT,
  EXPERT_ROLE,
  EXPERT_ROLE_TEXT,
  SUPER_ADMIN_ROLE,
  ROLE_SUPER_ADMIN_TEXT,
  COMPANY_ADMIN_ROLE,
  ROLE_COMPANY_ADMIN_TEXT,
  PARTNER_ROLE,
  PARTNER_ROLE_TEXT,
  COMPANY_MANAGER_ROLE,
  USER_INVITED_TEXT,
  USER_ACCEPTED_TEXT,
  USER_STATUS_ACCEPTED,
  USER_STATUS_INVITED,
  COMPANY_MANAGER_ROLE_TEXT,
  ASSOCIATED_USERS_TEXT,
  USERS_ROLE_TEXT
} from "../../roles/Constants";

//Add User Popup
import AddUserModal from "./AddUserModal";
import Page404 from "../Page404";
import {
  SETTINGS_ENABLE_EXPERTS,
  SETTINGS_ENABLE_PARTNERS,
  SETTINGS_ENABLE_CUSTOMERS,
  USERS_TAB
} from "../../setting/Constants";
import { isBadRequest } from "../../common/http";

const statusStyle = {
  borderRadius: "10px",
  color: "#FFFFFF",
  fontWeight: 600,
  width: "75px",
  fontSize: "12px",
  paddingLeft: "5px",
  paddingRight: "5px",
  backgroundColor: "#0AD4BB"
};

class users extends Component {
  state = {
    userRemoveModal: false,
    UserChangeRoleModal: false
  };
  constructor(props) {
    super(props);
    this.state = {
      activeTab: ROLE_SUPER_ADMIN_TEXT,
      roleId: 1,
      sortByOptions: [
        {
          value: "first_name:ASC",
          label: "Name"
        },
        {
          value: "createdAt:DESC",
          label: "Most Recent"
        }
      ],
      selectedSortOption: "Most Recent",
      searchParam: "",
      currentSuperAdminSort: "createdAt",
      currentSuperAdminSortDir: "DESC",
      currentCustomerSort: "createdAt",
      currentCustomerSortDir: "DESC",
      currentExpertSort: "createdAt",
      currentExpertSortDir: "DESC",
      currentParnerSort: "createdAt",
      currentPartnerSortDir: "DESC",
      roleNames: ""
    };
  }

  componentDidMount() {
    // Check is logged in user
    isLoggedIn();

    const params = new URLSearchParams(this.props.history.location.search);
    const role = params.get("type");

    this.setState({
      searchParam: role,
      activeTab: role || ROLE_SUPER_ADMIN_TEXT
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // Check is logged in user
    isLoggedIn();
    if (
      this.props.superAdminSort &&
      this.props.superAdminSort !== this.state.currentSuperAdminSort
    ) {
      this.setState({
        currentSuperAdminSort: this.props.superAdminSort
      });
    }
    if (
      this.props.superAdminSortDir &&
      this.props.superAdminSortDir !== this.state.currentSuperAdminSortDir
    ) {
      this.setState({
        currentSuperAdminSortDir: this.props.superAdminSortDir
      });
    }

    if (
      this.props.customerSort &&
      this.props.customerSort !== this.state.currentCustomerSort
    ) {
      this.setState({
        currentCustomerSort: this.props.customerSort
      });
    }
    if (
      this.props.customerSortDir &&
      this.props.customerSortDir !== this.state.currentCustomerSortDir
    ) {
      this.setState({
        currentCustomerSortDir: this.props.customerSortDir
      });
    }
    if (
      this.props.expertSort &&
      this.props.expertSort !== this.state.currentExpertSort
    ) {
      this.setState({
        currentExpertSort: this.props.expertSort
      });
    }
    if (
      this.props.expertSortDir &&
      this.props.expertSortDir !== this.state.currentExpertSortDir
    ) {
      this.setState({
        currentExpertSortDir: this.props.expertSortDir
      });
    }
    if (
      this.props.partnerSort &&
      this.props.partnerSort !== this.state.currentParnerSort
    ) {
      this.setState({
        currentParnerSort: this.props.partnerSort
      });
    }
    if (
      this.props.partnerSortDir &&
      this.props.partnerSortDir !== this.state.currentPartnerSortDir
    ) {
      this.setState({
        currentPartnerSortDir: this.props.partnerSortDir
      });
    }

    const { search } = prevProps.history.location;
    const params = new URLSearchParams(search);
    const role = params.get("type");
    // Set current active tab
    if (this.state.searchParam !== role) {
      this.setState({
        searchParam: role,
        activeTab: role || ROLE_SUPER_ADMIN_TEXT
      });
    }
  }
  close = () => {
    this.setState({ UserRemoveModal: false });
    this.setState({ UserChangeRoleModal: false });
  };

  toggleUserRemoveModal = userData => {
    this.setState({
      UserRemoveModal: !this.state.UserRemoveModal,
      id: userData.id,
      firstName: userData.firstName,
      lastName: userData.lastName,
      avatarUrl: userData.avatarUrl,
      email: userData.email
    });
  };

  toggleUserChangeRoleModal = userData => {
    this.setState({
      UserChangeRoleModal: !this.state.UserChangeRoleModal,
      id: userData.id,
      firstName: userData.firstName,
      lastName: userData.lastName,
      avatarUrl: userData.avatarUrl,
      email: userData.email,
      role: userData.roleName
    });
  };
  toggle = tab => {
    this.setState({
      activeTab: tab
    });

    this.props.history.push(`/users?type=${tab}`);
  };

  // handle resend invite
  resendInvite = async member => {
    try {
      const response = await apiClient.post(
        `${endpoints().userAPI}/resendInvite`,
        member
      );
      let successMessage;
      if (response && response.data) {
        successMessage = response.data.message;
        toast.success(successMessage);
      }
    } catch (error) {
      if (isBadRequest(error)) {
        let errorMessage;
        const errorRequest = error.response.request;
        if (errorRequest && errorRequest.response) {
          errorMessage = JSON.parse(errorRequest.response).message;
        }
        toast.error(error.response.data.message, {
          containerId: "Team-Member-toast"
        });
        console.error(errorMessage);
      }
    }
  };

  // handle resend invite
  resetPassword = async member => {
    try {
      const response = await apiClient.post(
        `${endpoints().userAPI}/resetPassword`,
        member
      );
      let successMessage;
      if (response && response.data) {
        successMessage = response.data.message;
        toast.success(successMessage);
      }
    } catch (error) {
      if (isBadRequest(error)) {
        let errorMessage;
        const errorRequest = error.response.request;

        if (errorRequest && errorRequest.response) {
          errorMessage = JSON.parse(errorRequest.response).message;
        }
        toast.error(error.response.data.message, {
          containerId: "Team-Member-toast"
        });
        console.error(errorMessage);
      }
    }
  };

  // Remove user
  handleRemove = (id, page) => {
    apiClient
      .delete(`${endpoints().userAPI}/${id}`)
      .then(response => {
        let successMessage;
        if (response && response.data) {
          successMessage = response.data.message;
          toast.success(successMessage);
          const sort = this.state.currentSuperAdminSort;
          // Get current tab name
          const currentTab = this.props.id;
          const searchItem = getParamsByName("search");
          const searchTerm = searchItem ? searchItem.trim() : "";

          const sortDir = getParamsByName("sortDir");
          this.props.actions.fetchList(
            ROLE_SUPER_ADMIN_TEXT,
            `${endpoints().userAPI}/search`,
            1,
            10,
            {
              sort: sort || this.state.currentSuperAdminSort,
              search: encodeURIComponent(searchTerm),
              sortDir: sortDir || this.state.currentSuperAdminSortDir,
              roleIds:
                currentTab === ROLE_SUPER_ADMIN_TEXT
                  ? `${SUPER_ADMIN_ROLE}`
                  : currentTab === USERS_ROLE_TEXT
                  ? `${COMPANY_ADMIN_ROLE},${COMPANY_MANAGER_ROLE},${PARTNER_ROLE},${CUSTOMER_ROLE}`
                  : `${COMPANY_ADMIN_ROLE},${COMPANY_MANAGER_ROLE}`,
              pagination: true
            }
          );
          this.props.actions.fetchList(
            PARTNER_ROLE_TEXT,
            `${endpoints().userAPI}/search`,
            1,
            10,
            {
              sort: sort || this.state.currentParnerSort,
              sortDir: sortDir || this.state.currentPartnerSortDir,
              roleIds: PARTNER_ROLE,
              pagination: true
            }
          );
          this.props.actions.fetchList(
            CUSTOMER_ROLE_TEXT,
            `${endpoints().userAPI}/search`,
            1,
            10,
            {
              sort: sort || this.state.currentCustomerSort,
              sortDir: sortDir || this.state.currentCustomerSortDir,
              roleIds: CUSTOMER_ROLE,
              pagination: true
            }
          );
          this.props.actions.fetchList(
            EXPERT_ROLE_TEXT,
            `${endpoints().userAPI}/search`,
            1,
            10,
            {
              sort: sort || this.state.currentExpertSort,
              sortDir: sortDir || this.state.currentExpertSortDir,
              roleIds: EXPERT_ROLE,
              pagination: true
            }
          );
        }
      })

      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          toast.error(errorMessage);
        }
      });
  };

  // Handle User Role
  handleUserRole = async (data, id, emailId) => {
    const sort = getParamsByName("sort");
    const sortDir = getParamsByName("sortDir");
    const searchTerm = getParamsByName("search").trim();
    const type = getParamsByName("type");

    const role =
      data === ROLE_SUPER_ADMIN_TEXT
        ? SUPER_ADMIN_ROLE
        : data === ROLE_COMPANY_ADMIN_TEXT
        ? COMPANY_ADMIN_ROLE
        : data === PARTNER_ROLE_TEXT
        ? PARTNER_ROLE
        : data === EXPERT_ROLE_TEXT
        ? EXPERT_ROLE
        : data === CUSTOMER_ROLE_TEXT
        ? CUSTOMER_ROLE
        : data === COMPANY_MANAGER_ROLE_TEXT
        ? COMPANY_MANAGER_ROLE
        : null;

    try {
      const response = await apiClient.put(`${endpoints().userAPI}/${id}`, {
        roleId: role,
        email: emailId
      });
      let successMessage;
      if (response && response.data) {
        successMessage = response.data.message;
        toast.success(successMessage);
        this.props.actions.fetchList(
          ROLE_SUPER_ADMIN_TEXT,
          `${endpoints().userAPI}/search`,
          1,
          10,
          {
            sort: sort || this.state.currentSuperAdminSort,
            sortDir: sortDir || this.state.currentSuperAdminSortDir,
            roleIds: `${COMPANY_ADMIN_ROLE},${COMPANY_MANAGER_ROLE}`,
            pagination: true,
            search: type === ROLE_SUPER_ADMIN_TEXT ? searchTerm : "",
            type: ROLE_SUPER_ADMIN_TEXT
          }
        );
        this.props.actions.fetchList(
          PARTNER_ROLE_TEXT,
          `${endpoints().userAPI}/search`,
          1,
          10,
          {
            sort: sort || this.state.currentParnerSort,
            sortDir: sortDir || this.state.currentPartnerSortDir,
            roleIds: PARTNER_ROLE,
            pagination: true
          }
        );
        this.props.actions.fetchList(
          CUSTOMER_ROLE_TEXT,
          `${endpoints().userAPI}/search`,
          1,
          10,
          {
            sort: sort || this.state.currentCustomerSort,
            sortDir: sortDir || this.state.currentCustomerSortDir,
            roleIds: CUSTOMER_ROLE,
            pagination: true
          }
        );
        this.props.actions.fetchList(
          EXPERT_ROLE_TEXT,
          `${endpoints().userAPI}/search`,
          1,
          10,
          {
            sort: sort || this.state.currentExpertSort,
            sortDir: sortDir || this.state.currentExpertSortDir,
            roleIds: EXPERT_ROLE,
            pagination: true
          }
        );
      }
    } catch (error) {
      if (isBadRequest(error)) {
        let errorMessage;
        const errorRequest = error.response.request;
        if (errorRequest && errorRequest.response) {
          errorMessage = JSON.parse(errorRequest.response).message;
        }
        toast.error(error.response.data.message);
      }
    }
  };

  renderUserTableByRoleId(roleIds, roleName, invitedUsers) {
    const currentUrl = window.location.pathname + window.location.search;
    const search = window.location.search;
    let role = getParamsByName("type") || ROLE_SUPER_ADMIN_TEXT;
    const apiUrl =
      invitedUsers && invitedUsers == "true"
        ? "/v1/user/associated/users"
        : "/v1/user/search";
    const pathParams = new URLSearchParams(search);

    const searchItem = pathParams.get("search");
    return (
      <div className="mb-5 text-break">
        <ReduxTable
          id={roleName}
          showHeader
          searchPlaceholder="Search"
          newTableHeading
          icon={<UserIcon />}
          message="Get started by selecting New User."
          apiURL={apiUrl}
          params={{ roleIds, type: role, search: searchItem }}
          sortByOptions={this.state.sortByOptions}
          paramsToUrl={true}
          history={this.props.history}
        >
          <ReduxColumn
            width={this.props.supportPortal ? "105px" : "115px"}
            field="firstName"
            type="link"
            isClickable="true"
            sortBy="first_name"
            renderField={row => (
              <Link to={`/user/edit/${row.id}?redirect=/users${currentUrl}`}>
                <AvatarCard
                  firstName={row.firstName}
                  lastName={row.lastName}
                  url={row.avatarUrl}
                />
              </Link>
            )}
          >
            Name
          </ReduxColumn>
          <ReduxColumn
            width={this.props.supportPortal ? "105px" : "115px"}
            field="email"
            sortBy="email"
          >
            Email
          </ReduxColumn>
          <ReduxColumn
            width={this.props.supportPortal ? "105px" : "115px"}
            field="roleName"
          >
            Role
          </ReduxColumn>
          <ReduxColumn
            width={this.props.supportPortal ? "105px" : "115px"}
            field="status"
            renderField={row => (
              <div className="actions">
                <p
                  className={`text-center ${
                    row.status === USER_STATUS_INVITED
                      ? "bg-secondary"
                      : row.status === USER_STATUS_ACCEPTED
                      ? row.status === null
                      : "bg-white"
                  }`}
                  style={statusStyle}
                  disableOnClick
                >
                  {row.status === USER_STATUS_INVITED
                    ? USER_INVITED_TEXT
                    : row.status === USER_STATUS_ACCEPTED
                    ? USER_ACCEPTED_TEXT
                    : row.status === null
                    ? null
                    : USER_INVITED_TEXT}
                </p>
              </div>
            )}
          >
            Invite Status
          </ReduxColumn>
          <ReduxColumn
            Width="105px"
            field="Action"
            disableOnClick
            renderField={row => (
              <div className="text-center landing-group-dropdown">
                <MoreDropdown>
                  {row.status === 0 && (
                    <DropdownItem
                      class=""
                      onClick={() => {
                        {
                          this.resendInvite({
                            id: row.id,
                            email: row.email,
                            status: row.status
                          });
                        }
                      }}
                    >
                      Resend Invite
                    </DropdownItem>
                  )}
                  {this.state.activeTab === ROLE_SUPER_ADMIN_TEXT &&
                    !isCompanyAdmin(this.props.roleId) &&
                    !isCompanyManager(this.props.roleId) && (
                      <DropdownItem
                        onClick={() => {
                          this.setState({
                            id: row.id,
                            email: row.email,
                            status: row.status,
                            roleNames: row.roleName
                          });
                          return this.toggleUserChangeRoleModal(row);
                        }}
                      >
                        Change Role
                      </DropdownItem>
                    )}

                  <DropdownItem
                    class=""
                    onClick={() => {
                      {
                        this.resetPassword({
                          id: row.id,
                          email: row.email,
                          status: row.status
                        });
                      }
                    }}
                  >
                    Reset Password
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      this.setState({
                        id: row.id,
                        email: row.email,
                        status: row.status
                      });
                      return this.toggleUserRemoveModal(row);
                    }}
                  >
                    Remove
                  </DropdownItem>
                </MoreDropdown>
              </div>
            )}
          >
            Action
          </ReduxColumn>
        </ReduxTable>
      </div>
    );
  }

  render() {
    const {
      activeTab,
      currentSuperAdminSort,
      currentSuperAdminSortDir,
      currentCustomerSort,
      currentCustomerSortDir,
      currentExpertSort,
      currentExpertSortDir,
      currentParnerSort,
      currentPartnerSortDir
    } = this.state;
    const currentParams = {
      currentSuperAdminSort,
      currentSuperAdminSortDir,
      currentCustomerSort,
      currentCustomerSortDir,
      currentExpertSort,
      currentExpertSortDir,
      currentParnerSort,
      currentPartnerSortDir
    };
    const settings = this.props.settings ? this.props.settings : "";

    const enableCustomers = settings
      ? getKeyValueByObject(settings, SETTINGS_ENABLE_CUSTOMERS)
      : "";

    const enablePartners = settings
      ? getKeyValueByObject(settings, SETTINGS_ENABLE_PARTNERS)
      : "";

    const enableExperts = settings
      ? getKeyValueByObject(settings, SETTINGS_ENABLE_EXPERTS)
      : "";

    const headerButton = (
      <AddUserModal
        supportPortal={this.props.supportPortal}
        currentParams={currentParams}
        activeTab={this.state.activeTab}
        id={this.props.id}
      />
    );

    if (
      !isSuperAdmin(this.props.roleId) &&
      !isCompanyAdmin(this.props.roleId) &&
      !isCompanyManager(this.props.roleId)
    ) {
      return <Page404 />;
    }
    let tab = this.props && this.props.match && this.props.match.params.tab;

    return (
      <>
        {/* /.page-heading */}
        {headerButton}
        <UserChangeRoleModal
          isOpen={this.state.UserChangeRoleModal}
          toggle={this.toggleUserChangeRoleModal}
          id={this.state.id}
          firstName={this.state.firstName}
          lastName={this.state.lastName}
          avatarUrl={this.state.avatarUrl}
          email={this.state.email}
          role={this.state.role}
          close={this.close}
          handleUserRole={this.handleUserRole}
          roleNames={this.state.roleNames}
        />
        <UserRemoveModal
          isOpen={this.state.UserRemoveModal}
          toggle={this.toggleUserRemoveModal}
          id={this.state.id}
          firstName={this.state.firstName}
          lastName={this.state.lastName}
          avatarUrl={this.state.avatarUrl}
          email={this.state.email}
          handleRemove={this.handleRemove}
          close={this.close}
          page={this.props.partnerCurrentPage}
        />
        {!this.props.supportPortal ? (
          <Nav tabs className="admin-tabs mb-0">
            <NavItem>
              <NavLink
                className={classnames({
                  active: activeTab === ROLE_SUPER_ADMIN_TEXT
                })}
                onClick={() => {
                  this.toggle(ROLE_SUPER_ADMIN_TEXT);
                }}
              >
                Admins
                <CountBadge
                  count={this.props.superAdminCount}
                  isActive={activeTab === ROLE_SUPER_ADMIN_TEXT}
                />
              </NavLink>
            </NavItem>
            {enablePartners && enablePartners === "true" && (
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === PARTNER_ROLE_TEXT
                  })}
                  onClick={() => {
                    this.toggle(PARTNER_ROLE_TEXT);
                  }}
                >
                  Partners
                  <CountBadge
                    count={this.props.partnerCount}
                    isActive={activeTab === PARTNER_ROLE_TEXT}
                  />
                </NavLink>
              </NavItem>
            )}
            {enableCustomers && enableCustomers === "true" && (
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === CUSTOMER_ROLE_TEXT
                  })}
                  onClick={() => {
                    this.toggle(CUSTOMER_ROLE_TEXT);
                  }}
                >
                  Customers
                  <CountBadge
                    count={this.props.customerCount}
                    isActive={activeTab === CUSTOMER_ROLE_TEXT}
                  />
                </NavLink>
              </NavItem>
            )}
            {enableExperts && enableExperts === "true" && (
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === EXPERT_ROLE_TEXT
                  })}
                  onClick={() => {
                    this.toggle(EXPERT_ROLE_TEXT);
                  }}
                >
                  Experts
                  <CountBadge
                    count={this.props.expertCount}
                    isActive={activeTab === EXPERT_ROLE_TEXT}
                  />
                </NavLink>
              </NavItem>
            )}
          </Nav>
        ) : (
          ""
        )}

        {!this.props.supportPortal ? (
          <TabContent activeTab={activeTab}>
            {/*User table*/}
            <TabPane tabId={PARTNER_ROLE_TEXT}>
              {this.renderUserTableByRoleId(PARTNER_ROLE, PARTNER_ROLE_TEXT)}
            </TabPane>
            <TabPane tabId={CUSTOMER_ROLE_TEXT}>
              {this.renderUserTableByRoleId(CUSTOMER_ROLE, CUSTOMER_ROLE_TEXT)}
            </TabPane>
            <TabPane tabId={EXPERT_ROLE_TEXT}>
              {this.renderUserTableByRoleId(EXPERT_ROLE, EXPERT_ROLE_TEXT)}
            </TabPane>
            <TabPane tabId={ROLE_SUPER_ADMIN_TEXT}>
              {this.renderUserTableByRoleId(
                `${COMPANY_ADMIN_ROLE},${COMPANY_MANAGER_ROLE}`,
                ROLE_SUPER_ADMIN_TEXT
              )}
            </TabPane>
          </TabContent>
        ) : (
          <TabContent activeTab={activeTab}>
            {/*User table*/}
            {this.props.id === ROLE_SUPER_ADMIN_TEXT && tab === USERS_TAB && (
              <TabPane tabId={ROLE_SUPER_ADMIN_TEXT}>
                {this.renderUserTableByRoleId(
                  `${SUPER_ADMIN_ROLE}`,
                  ROLE_SUPER_ADMIN_TEXT
                )}
              </TabPane>
            )}
            {this.props.supportPortal && this.props.id === USERS_TAB && (
              <TabPane tabId={ROLE_SUPER_ADMIN_TEXT}>
                {this.renderUserTableByRoleId(
                  `${CUSTOMER_ROLE},${PARTNER_ROLE},${COMPANY_MANAGER_ROLE},${COMPANY_ADMIN_ROLE},${EXPERT_ROLE}`,
                  ROLE_SUPER_ADMIN_TEXT
                )}
              </TabPane>
            )}
          </TabContent>
        )}
      </>
    );
  }
}

const UserRemoveModal = ({
  isOpen,
  toggle,
  id,
  firstName,
  lastName,
  avatarUrl,
  email,
  handleRemove,
  close,
  page
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className={["edit-task-modal"].join(" ")}
      backdrop="static"
    >
      <ModalHeader toggle={toggle}>
        <h4 className={["font-weight-bold"].join(" ")}>Remove User</h4>
      </ModalHeader>
      <ModalBody className={["mb-4"].join(" ")}>
        <div className=" d-flex">
          <Avatar
            firstName={firstName}
            lastName={lastName}
            size="customSize"
            imageSize={"48"}
            url={avatarUrl}
          />
          <p className="h6-5 font-weight-bold ml-3">
            <Link
              className="text-dark text-decoration-none"
              to={`/user/edit/${id}?redirect=/users?type=Partner`}
              style={{ cursor: "pointer" }}
            >
              {getFullName(firstName, lastName)}
            </Link>
            <div>
              <span className="font-weight-normal text-inline-grayed">
                ({email})
              </span>
            </div>
          </p>
        </div>
      </ModalBody>
      <ModalFooter className={["justify-content-center"].join(" ")}>
        <p className="font-weight-bold">Are you sure you want to remove ?</p>

        <div className="btn-wrapper mt-4 d-flex justify-content-center">
          <CancelButton
            onClick={() => {
              close();
            }}
            className="mr-2"
          />
          <button
            className="btn btn-secondary h6-5-important m-1"
            onClick={() => {
              handleRemove(id, page);
              setTimeout(() => {
                close();
              }, 100);
            }}
          >
            <span>Yes, Remove</span>
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

const UserChangeRoleModal = ({
  isOpen,
  toggle,
  id,
  firstName,
  lastName,
  avatarUrl,
  email,
  role,
  close,
  handleUserRole,
  roleNames
}) => {
  const [roleName, setRole] = useState();
  const handleChange = data => {
    const selectedRole = data.values.userRole.label;
    setRole(selectedRole);
  };
  return (
    <Modal isOpen={isOpen} className={["edit-task-modal"].join(" ")}>
      <ModalHeader toggle={toggle}>
        <h4 className={["font-weight-bold"].join(" ")}>Change User Role</h4>
      </ModalHeader>
      <Form
        onSubmit={() => {
          if (roleName) {
            handleUserRole(roleName, id, email);
            setTimeout(() => {
              close();
            }, 100);
          }
        }}
      >
        <ModalBody className={["mb-4"].join(" ")}>
          <div className="row">
            <Avatar
              firstName={firstName}
              lastName={lastName}
              size="customSize"
              imageSize={"48"}
              url={avatarUrl}
            />
            <p className="h6-5 font-weight-bold ml-3">
              <Link
                className="text-dark text-decoration-none"
                to={`/user/edit/${id}?redirect=/users?type=Partner`}
                style={{ cursor: "pointer" }}
              >
                {getFullName(firstName, lastName)}
              </Link>

              <div>
                <span className="font-weight-normal text-inline-grayed">
                  ({email})
                </span>
              </div>
            </p>
          </div>
          <div className="row">
            <p className="font-weight-bold ml-5 pl-3">User Role</p>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="w-50 ml-5">
                <UserRole
                  name="userRole"
                  onChange={handleChange}
                  placeholder={role}
                  roleNames={roleNames}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className={["justify-content-center"].join(" ")}>
          <div className="btn-wrapper text-center">
            <Button type="submit" label="">
              Change
            </Button>
          </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

const mapStateToProps = state => {
  const { Customer, Expert, Partner } = state.table;

  const { user } = state;

  const superAdminCount =
    state.table["Super Admin"] && !state.table["Super Admin"].isFetching
      ? state.table["Super Admin"].totalCount
      : 0;
  const superAdminSort =
    state.table["Super Admin"] && !state.table["Super Admin"].isFetching
      ? state.table["Super Admin"].sort
      : "";
  const superAdminSortDir =
    state.table["Super Admin"] && !state.table["Super Admin"].isFetching
      ? state.table["Super Admin"].sortDir
      : "";

  const roleId = user && !user.isFetching && user.roleId;

  const customerCount =
    Customer && !Customer.isFetching ? Customer.totalCount : 0;
  const customerSort = Customer && !Customer.isFetching ? Customer.sort : "";
  const customerSortDir =
    Customer && !Customer.isFetching ? Customer.sortDir : "";

  const expertCount = Expert && !Expert.isFetching ? Expert.totalCount : 0;
  const expertSort = Expert && !Expert.isFetching ? Expert.sort : "";
  const expertSortDir = Expert && !Expert.isFetching ? Expert.sortDir : "";

  const partnerSort = Partner && !Partner.isFetching ? Partner.sort : "";
  const partnerSortDir = Partner && !Partner.isFetching ? Partner.sortDir : "";
  const partnerCount = Partner && !Partner.isFetching ? Partner.totalCount : 0;
  const partnerCurrentPage =
    Partner && !Partner.isFetching ? Partner.currentPage : 1;

  return {
    superAdminCount,
    customerCount,
    expertCount,
    partnerCount,
    superAdminSort,
    superAdminSortDir,
    customerSort,
    customerSortDir,
    expertSort,
    expertSortDir,
    partnerSort,
    partnerSortDir,
    partnerCurrentPage,
    roleId
  };
};
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchList }, dispatch)
  };
}
// const mapStateToProps = state => {};

export default connect(() => {
  return mapStateToProps;
}, mapDispatchToProps)(users);
